import React, { ReactNode, createContext, useMemo, useReducer } from 'react';
import { buildSelectionFromQueryParam } from '@secretescapes/cauldron';
import { getParam } from '@utils/url.utils';
import { initialState, selectionActions, selectionReducer } from './selectionReducer';
import { SelectionState } from './selectionReducer.interfaces';

export const SelectionStateContext = createContext<SelectionState | undefined>(undefined);
export const SelectionActionsContext = createContext<
  ReturnType<typeof selectionActions> | undefined
>(undefined);

interface SelectionProviderProps {
  children: ReactNode;
}

export const SelectionProvider = ({ children }: SelectionProviderProps) => {
  const [state, dispatch] = useReducer(selectionReducer, initialState, getInitialState);

  const actions = useMemo(() => selectionActions(dispatch), [dispatch]);

  return (
    <SelectionStateContext.Provider value={state}>
      <SelectionActionsContext.Provider value={actions}>
        {children}
      </SelectionActionsContext.Provider>
    </SelectionStateContext.Provider>
  );
};

const getInitialState = (defaultState: SelectionState): SelectionState => {
  const { travellersSelectionParam } = getInitialUrlState();

  return {
    ...defaultState,
    travellersSelection: travellersSelectionParam
      ? buildSelectionFromQueryParam(travellersSelectionParam)
      : defaultState.travellersSelection,
  };
};

const getInitialUrlState = () => {
  return {
    travellersSelectionParam: getParam('travellersSelection') ?? undefined,
  };
};
